import mustache from "mustache";
import { BaseRequest } from "../../../../../base/request/BaseRequest";
import { IFormField } from "../../../../definitions/form/IFormField";
import { FarmTypeSelectorConfig } from "./FarmTypeSelectorConfig";
import template from "./farmTypeSelectorTemplate.html";

mustache.parse(template);

const TIPO_AGRICULTURA = 0;
const TIPO_GANADERIA = 1;

/** Contador para ids únicos por instancia. */
let FARM_TYPE_SELECTOR_ID = 0;

/** Selector de tipo de finca (2 tarjetas: Agricultura/Ganadería). `IFormField`
 *  sin catálogo: las 2 opciones son fijas. */
export class FarmTypeSelectorField<TRequest extends BaseRequest>
  implements IFormField
{
  private readonly _fieldId: number;
  private readonly _request: TRequest;
  private readonly _config: FarmTypeSelectorConfig<TRequest>;

  constructor(request: TRequest, config: FarmTypeSelectorConfig<TRequest>) {
    FARM_TYPE_SELECTOR_ID += 1;
    this._fieldId = FARM_TYPE_SELECTOR_ID;
    this._request = request;
    this._config = config;
  }

  getId(): string {
    return `farm-type-selector-${this._fieldId}`;
  }

  render(): string {
    const tipo = this._config.get(this._request);
    return mustache.render(template, {
      id: this._fieldId,
      label: this._config.label,
      agriculturaSelected: tipo === TIPO_AGRICULTURA,
      ganaderiaSelected: tipo === TIPO_GANADERIA,
    });
  }

  connect(): void {
    this._cardAgricultura = document.getElementById(
      `farm-type-card-agricultura-${this._fieldId}`,
    );
    this._cardGanaderia = document.getElementById(
      `farm-type-card-ganaderia-${this._fieldId}`,
    );
    this._error = document.getElementById(`farm-type-error-${this._fieldId}`);

    this._cardAgricultura?.addEventListener("click", this._onSelectAgricultura);
    this._cardGanaderia?.addEventListener("click", this._onSelectGanaderia);
  }

  dispose(): void {
    this._cardAgricultura?.removeEventListener(
      "click",
      this._onSelectAgricultura,
    );
    this._cardGanaderia?.removeEventListener("click", this._onSelectGanaderia);
  }

  getError(): string | null {
    return this._config.get(this._request) === null
      ? "Seleccione el tipo de finca"
      : null;
  }

  showError(): void {
    if (this._error) this._error.innerHTML = this.getError() ?? "";
  }

  focus(): void {
    this._cardAgricultura?.focus();
  }

  disabled(): void {
    this._isDisabled = true;
    this._cardAgricultura?.classList.add("disabled");
    this._cardGanaderia?.classList.add("disabled");
  }

  enabled(): void {
    this._isDisabled = false;
    this._cardAgricultura?.classList.remove("disabled");
    this._cardGanaderia?.classList.remove("disabled");
  }

  private _isDisabled = false;
  private _cardAgricultura: HTMLElement | null = null;
  private _cardGanaderia: HTMLElement | null = null;
  private _error: HTMLElement | null = null;

  private _onSelectAgricultura = (): void => this._select(TIPO_AGRICULTURA);
  private _onSelectGanaderia = (): void => this._select(TIPO_GANADERIA);

  private _select = (tipo: number): void => {
    if (this._isDisabled) return;

    this._config.set(this._request, tipo);
    this._cardAgricultura?.classList.toggle(
      "selected",
      tipo === TIPO_AGRICULTURA,
    );
    this._cardGanaderia?.classList.toggle("selected", tipo === TIPO_GANADERIA);
    this.showError();
  };
}
